<template>
    <div>
        <v-hover
            v-slot="{ hover }"
        >
            <v-card 
                :elevation="hover ? 6 : 1"
                class="mx-auto custom-card" 
                variant="outlined" 
                style="background-color: white;"
            >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                            <slide-single :items="item.photos_total" />
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                            <v-row dense>
                                <!-- Codigo e datas -->
                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <span>
                                            <v-chip
                                                color="blue"
                                                label
                                                text-color="white"
                                                class="font-weight-medium text-h7"
                                            >
                                            COD: {{ item.codigo }} 
                                            </v-chip>   
                                        </span>
                                        <span class="ml-2">
                                            <v-chip
                                                :color="item.status | statusProperty"
                                                label
                                                text-color="black"
                                                class="font-weight-medium text-h7"
                                            >
                                                {{ item.status }}
                                            </v-chip> 
                                        </span>
                                        <span class="ml-2 text-h7 black--text font-weight-medium">
                                            {{ item.tipo_imovel }}
                                            <span v-if="item.tipo_imovel == 'Conjunto'"> {{ item.finalidade }}</span> 
                                            <span v-if="(showSubTipoImovel(item) != '')"> 
                                                ( {{showSubTipoImovel(item)}} )
                                            </span> 
                                        </span>   
                                </v-col> 

                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <span class="text-h7 black--text font-weight-medium">  
                                        DT CAD.: 
                                        <span v-if="item.created_at"> {{ formatDate(item.created_at) }}</span>
                                    </span>
                                    <span class="ml-2 text-h7 black--text font-weight-medium">  
                                        DT AT.: 
                                        <span v-if="item.data_atualizacao"> {{ item.data_atualizacao }}</span>
                                    </span>
                                </v-col>        
                            </v-row>
                            <!-- Fim codigo e datas -->


                            <!-- endereco -->
                            <v-row dense>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 font-weight-light black--text' : 'text-subtitle-1 font-weight-light black--text'">
                                        {{ item.endereco }}
                                        <span v-if="item.numero">, {{ item.numero }} </span>
                                        <span v-if="item.apartamento"> - Apto: {{ item.apartamento }} </span>
                                        <span v-if="item.andar">  - {{ item.andar }} andar </span>
                                        <span v-if="item.tower && item.tower.nome != ''"> - Torre: {{ item.tower.nome }} </span>
                                        <span v-if="item.complemento"> - Compl: {{ item.complemento }} </span>
                                        <span v-if="item.bairro">  - {{ item.bairro }} </span>
                                        <span v-if="item.cidade">  - {{ item.cidade }} </span>
                                        <span v-if="item.estado">  - {{ item.estado }} </span>
                                        <span v-if="item.cep">  - {{ item.cep | VMask('#####-###') }} </span>
                                    </div> 
                                </v-col>                                        
                            </v-row>  
                            <!-- fim endereco -->

                            <!-- dados principais buttons -->
                            <v-row dense>
                                <v-col cols="auto" v-if="item.area">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                        block
                                    >
                                        <span>{{ item.tipo_imovel | labelArea('area') }} {{ item.area }} m²</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.area_total">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                    >
                                        <span>{{ item.tipo_imovel | labelArea('area_total') }} {{ item.area_total }} m²</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.area_construida_terreno">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                    >
                                        <span>A. const. terr. {{ item.area_construida_terreno }} m²</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.dormitorios">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label 
                                        outlined
                                        color="black"
                                        dark
                                    >
                                    <span>{{ item.dormitorios }} dorm(s)</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.suites">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                    >
                                    <span>{{ item.suites }} suite(s)</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.banheiros">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                    >
                                    <span>{{ item.banheiros }} banheiro(s)</span> 
                                    </v-chip>
                                </v-col>
                                <v-col cols="auto" v-if="item.vagas">
                                    <v-chip
                                        :small="$vuetify.breakpoint.smAndDown"
                                        label
                                        outlined
                                        color="black"
                                        dark
                                    >
                                    <span>{{ item.vagas }} vaga(s)</span> 
                                    </v-chip>
                                </v-col> 
                            </v-row>  
                            <!-- fim dados principais buttons -->  


                            <!-- colaboradores -->
                            <v-row dense>
                                <v-col class="font-weight-light black--text" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                     Colaboradores: 
                                    <span v-for="(colab, index) in item.colaborators" :key="colab.id">
                                        {{ colab.name }}
                                        <span v-if="(index + 1) < item.colaborators.length">, </span>
                                    </span>
                                </v-col>    
                            </v-row>
                            <!-- fim colaboradores -->

                            <!-- valores -->
                            <v-row dense>
                                <v-col cols="auto" v-if="item.valor_venda && item.valor_venda > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                    Venda {{ item.valor_venda | toCurrency }}
                                </v-col> 
                                <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                    Locaçāo {{ item.valor_locacao | toCurrency }}
                                </v-col>
                                <v-col cols="auto" v-if="item.valor_condominio && item.valor_condominio > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                    Cond. {{ item.valor_condominio | toCurrency }}
                                </v-col>
                                <v-col cols="auto" v-if="item.valor_iptu && item.valor_iptu > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                    IPTU {{ item.valor_iptu | toCurrency }}
                                </v-col> 
                                <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                    Total {{ setTotal(item) | toCurrency }}
                                </v-col>  
                            </v-row>
                            <!-- fim valores -->


                            <div class="mt-1 mb-1">
                                <v-row
                                    dense
                                >
                                    <v-col cols="auto">
                                        <favorite-button-component :object="item" :outlined="true" :small="$vuetify.breakpoint.smAndDown ? true : false"></favorite-button-component>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on">
                                                    <button-share-component :object="item" :outlined="true" :small="$vuetify.breakpoint.smAndDown ? true : false"></button-share-component>
                                                </div>
                                            </template>
                                            <span>Compartilhar</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col v-if="me.profile == 'Master' || me.profile == 'Gerente'" cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="setDialog('portals',item)"
                                                    :small="$vuetify.breakpoint.smAndDown"
                                                >
                                                    <v-icon left>mdi-hub</v-icon> Portal
                                                </v-btn>
                                            </template>
                                            <span>Portais de propaganda</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    :small="$vuetify.breakpoint.smAndDown" 
                                                    block 
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="setDialog('slideshow',item)"
                                                >
                                                    <v-icon left>mdi-camera</v-icon> SlideShow
                                                </v-btn>
                                            </template>
                                            <span>Slide Show</span>
                                        </v-tooltip>
                                    </v-col> 
                                    <v-col cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    :small="$vuetify.breakpoint.smAndDown" 
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="setDialog('showitem',item)"
                                                >
                                                    <v-icon left>mdi-eye</v-icon> Ficha
                                                </v-btn>
                                            </template>
                                            <span>Visualizar Ficha</span>
                                        </v-tooltip>
                                    </v-col> 
                                    <v-col cols="auto" 
                                        v-if="
                                            item.status == 'Pendente' 
                                            ? can('Edita imóvel pendente', { item: item }) 
                                            : can('Edita imóvel ativo da carteira', { item: item })"
                                    >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-if="item.status != 'Pendente'" 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button"
                                                    :small="$vuetify.breakpoint.smAndDown"  
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="alertPendente()"
                                                >
                                                    <v-icon left>mdi-pencil</v-icon> Editar
                                                </v-btn>

                                                <v-btn v-if="item.status == 'Pendente'" 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    :small="$vuetify.breakpoint.smAndDown" 
                                                    depressed 
                                                    outlined
                                                    @click.prevent="editItem(item.id)"
                                                >
                                                    <v-icon left>mdi-pencil</v-icon> Editar
                                                </v-btn>
                                            </template>
                                            <span>Edita Ficha</span>
                                        </v-tooltip>
                                    </v-col> 

                                    <v-col v-else cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button"
                                                    :small="$vuetify.breakpoint.smAndDown"  
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="openCloseDialog()"
                                                >
                                                    <v-icon left>mdi-swap-horizontal</v-icon>
                                                    <span v-if="$vuetify.breakpoint.smAndDown">
                                                        Sol. Alt.
                                                    </span>
                                                    <span v-else>
                                                        SOLICITAR ALTERAÇÃO
                                                    </span>
                                                    
                                                </v-btn>
                                            </template>
                                            <span>SOLICITAR ALTERAÇÃO</span>
                                        </v-tooltip>
                                    </v-col>

                                    <v-col cols="auto" 
                                        v-if="shouldDeleteReport"
                                    >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    :class="$css_button" 
                                                    block 
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="confirmDestroy(item)" 
                                                    color="red"
                                                    :small="$vuetify.breakpoint.smAndDown"      
                                                >
                                                    <v-icon left v-bind="attrs" v-on="on">mdi-delete</v-icon> EXCLUIR
                                                </v-btn>
                                            </template>
                                            <span>Excluir</span>
                                        </v-tooltip>
                                    </v-col>

                                </v-row>
                            </div>    

                        </v-col>
                    </v-row>
                </v-card-text>    
            </v-card>
        </v-hover>  



        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                    O status será alterado para Pendente.
                </v-card-title>
                    <v-card-text>Após concluir a edição não esqueça de alterar o status caso necessário. Caso não tenha acesso de alteração de status solicite junto a sua gerência.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="alertPendente()"
                    >
                        Fechar
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="setPendente(item.id)"
                    >
                        Prosseguir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Dialog -->
        <v-dialog 
            class="d-print-none"
            v-model="dialog_request" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
                class="d-print-none"
            >    
            </v-system-bar>    

            <v-card class="d-print-none" >
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'" >

                    <span>
                        Solicitação de alteração
                    </span>
                    
                    <span v-if="item.codigo" class="ml-2">- Código {{ item.codigo }} </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="openCloseDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <store-user-request-component :object="user_requests"></store-user-request-component>
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->


    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SlideSingle from '@/components/slideshow/SlideSingle.vue';
import FavoriteButtonComponent from '@/components/favoritebutton/FavoriteButtonComponent.vue';
import ButtonShareComponent from '@/components/button_share/ButtonShareComponent.vue';
import StoreUserRequestComponent from '@/components/user_requests/partials/StoreUserRequestComponent.vue';

export default {
    components: {
        SlideSingle,
        FavoriteButtonComponent,
        ButtonShareComponent,
        StoreUserRequestComponent
    },

    computed: {
        ...mapGetters('permissions', ['can']),
        
        me () {
            return this.$store.state.auth.me
        },

        tenant() {
            return this.$store.state.tenants.items.data    
        },

        shouldDeleteReport() {
            if(this.me.profile != 'Master') return false;
            return this.tenant?.[0]?.json_params?.delete_report === 'true';
        }
    }, 

    props: {
        item: {
            type: Object, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },
    },

    data () {
        return {
            dialog: false,
            dialog_request: false,
            user_requests: {
                model: 'properties',
                item_id: '',
                subject: 'Solicitação de alteração',
                object: {}
            },
        }
    },

    methods: {
        setDialog(module, item){
            const params = {};
            params.module = module;
            params.item = item; 
            this.$emit('callSetDialog', params);
        },

        alertPendente(){
            this.dialog = !this.dialog;
        }, 
        
        openCloseDialog(){
            this.user_requests.item_id = null;
            this.user_requests.object = null;
            if(!this.dialog_request){
                this.user_requests.item_id = this.item.id;
                this.user_requests.object = this.item;
            }
            this.dialog_request = !this.dialog_request;
        },

        setPendente(id){
            const params = {};
            params.id = id;
            params.status = 'Pendente';
            this.$store.dispatch('updatePropertyStatus', params)
                        .then(response => {
                            this.editItem(id);
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },
        
        editItem(id){
            this.$router.push({
                name: 'admin.properties2.edit',
                params: { uuid: id }
            });
        },

        confirmDestroy(item) {
            this.$snotify.warning(`Tem certeza que deseja excluir esse registro?`, 'Confirmaçāo', {
                timeout: 10000,
                showProgressBar: true,
                closeоnClick: true,
                buttons: [
                    {text: 'Nāo', action: this.$snotify.remove()},
                    {text: 'Sim', action: () => {
                        this.destroy(item)
                        this.$snotify.remove()
                    }},
                ]
            })
        },

        destroy(item){
            this.$emit('callDestroyProperty', item.id);
        }
    }
}
</script>